module.exports = __webpack_public_path__ + "img/ME.23a0a217.svg";